import createIcon from '../../createIcon';

/**
 * @component @name Assignment
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEgxNC44MkMxNC40IDIuODQgMTMuMyAyIDEyIDJDMTAuNyAyIDkuNiAyLjg0IDkuMTggNEg1QzMuOSA0IDMgNC45IDMgNlYyMEMzIDIxLjEgMy45IDIyIDUgMjJIMTlDMjAuMSAyMiAyMSAyMS4xIDIxIDIwVjZDMjEgNC45IDIwLjEgNCAxOSA0Wk0xMiA0QzEyLjU1IDQgMTMgNC40NSAxMyA1QzEzIDUuNTUgMTIuNTUgNiAxMiA2QzExLjQ1IDYgMTEgNS41NSAxMSA1QzExIDQuNDUgMTEuNDUgNCAxMiA0Wk0xNCAxOEg3VjE2SDE0VjE4Wk0xNyAxNEg3VjEySDE3VjE0Wk0xNyAxMEg3VjhIMTdWMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Assignment = createIcon('Assignment', [
  [
    'path',
    {
      d: 'M19 4H14.82C14.4 2.84 13.3 2 12 2C10.7 2 9.6 2.84 9.18 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 4C12.55 4 13 4.45 13 5C13 5.55 12.55 6 12 6C11.45 6 11 5.55 11 5C11 4.45 11.45 4 12 4ZM14 18H7V16H14V18ZM17 14H7V12H17V14ZM17 10H7V8H17V10Z',
      key: '103srn',
    },
  ],
]);

export default Assignment;
